import cn from "@/v2-ui/utils/utils.cn"
import { errorToast, toast } from "@/v2-ui/toast"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import { useUserAccountEmailMutation } from "@/v2-backoffice-client/user/accountEmail/user.accountEmail.mutation"

export type UserAccountEmailButtonProps = Omit<
  TooltipButtonProps,
  "content"
> & {
  userId: number | null | undefined
  password: string | null | undefined
}

function UserAccountEmailButton(props: UserAccountEmailButtonProps) {
  const { userId, password, className, ...buttonProps } = props
  const [sendAccountEmail, { loading, error }] = useUserAccountEmailMutation({
    // An email leaving the building is invisible on screen; say it went.
    onCompleted() {
      toast({ variant: "success", title: "Account email sent" })
    },
  })

  errorToast(error, { title: "Failed to send account email" })

  return (
    <TooltipButton
      className={cn(className, "relative")}
      iconSrc="paper-plane"
      content="Send account info over email"
      disabled={!userId || !password || loading}
      isLoading={loading}
      onClick={() => {
        if (!userId || !password) return
        sendAccountEmail({
          variables: {
            id: userId,
            password,
          },
        })
      }}
      {...buttonProps}
    />
  )
}

export default UserAccountEmailButton
